const getTintColorFromLevel = ({ theme }) => {
  return theme.colors.buttonActive;
};

export default getTintColorFromLevel;
